/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { DiceRollerV5, DiceRollerV5Interface } from "../DiceRollerV5";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "random",
        type: "uint256",
      },
    ],
    name: "DiceRoll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "getLatestRoll",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "random",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "name",
                type: "bytes32",
              },
              {
                internalType: "int256",
                name: "value",
                type: "int256",
              },
            ],
            internalType: "struct IDiceRollsV5.PerformancePair[]",
            name: "performances",
            type: "tuple[]",
          },
          {
            internalType: "uint256",
            name: "blockNumber",
            type: "uint256",
          },
        ],
        internalType: "struct IDiceRollsV5.RollParams",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "last",
        type: "uint256",
      },
    ],
    name: "getRange",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "random",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "name",
                type: "bytes32",
              },
              {
                internalType: "int256",
                name: "value",
                type: "int256",
              },
            ],
            internalType: "struct IDiceRollsV5.PerformancePair[]",
            name: "performances",
            type: "tuple[]",
          },
          {
            internalType: "uint256",
            name: "blockNumber",
            type: "uint256",
          },
        ],
        internalType: "struct IDiceRollsV5.RollParams[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoll",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "random",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "bytes32",
                name: "name",
                type: "bytes32",
              },
              {
                internalType: "int256",
                name: "value",
                type: "int256",
              },
            ],
            internalType: "struct IDiceRollsV5.PerformancePair[]",
            name: "performances",
            type: "tuple[]",
          },
          {
            internalType: "uint256",
            name: "blockNumber",
            type: "uint256",
          },
        ],
        internalType: "struct IDiceRollsV5.RollParams",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "latest",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "random",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32",
          },
          {
            internalType: "int256",
            name: "value",
            type: "int256",
          },
        ],
        internalType: "struct IDiceRollsV5.PerformancePair[]",
        name: "performance",
        type: "tuple[]",
      },
    ],
    name: "roll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rolls",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "random",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class DiceRollerV5__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DiceRollerV5> {
    return super.deploy(overrides || {}) as Promise<DiceRollerV5>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): DiceRollerV5 {
    return super.attach(address) as DiceRollerV5;
  }
  connect(signer: Signer): DiceRollerV5__factory {
    return super.connect(signer) as DiceRollerV5__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DiceRollerV5Interface {
    return new utils.Interface(_abi) as DiceRollerV5Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DiceRollerV5 {
    return new Contract(address, _abi, signerOrProvider) as DiceRollerV5;
  }
}
